/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 AppBar — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviations from MUI defaults: no box-shadow (flat), nav-bg/nav-fg tokens replace
// MUI primary/secondary palette mapping, no transition.

export const MuiAppBarLightOverrides = {
  root: {
    display: 'flex' as const,
    flexDirection: 'column' as const,
    width: '100%',
    boxSizing: 'border-box' as const,
    flexShrink: 0,
    boxShadow: 'none',
    transition: 'none',
  },

  positionFixed: {
    position: 'fixed' as const,
    top: 0,
    left: 'auto',
    right: 0,
    '@media print': {
      position: 'absolute' as const,
    },
  },

  positionAbsolute: {
    position: 'absolute' as const,
    top: 0,
    left: 'auto',
    right: 0,
  },

  positionSticky: {
    position: 'sticky' as const,
    top: 0,
    left: 'auto',
    right: 0,
  },

  positionStatic: {
    position: 'static' as const,
  },

  positionRelative: {
    position: 'relative' as const,
  },

  colorDefault: {
    backgroundColor: 'var(--ns-nav-bg)',
    color: 'var(--ns-nav-fg)',
  },

  colorPrimary: {
    backgroundColor: 'var(--ns-nav-bg)',
    color: 'var(--ns-nav-fg)',
  },

  colorSecondary: {
    backgroundColor: 'var(--ns-nav-bg)',
    color: 'var(--ns-nav-fg)',
  },

  colorInherit: {
    color: 'inherit',
  },

  colorTransparent: {
    backgroundColor: 'transparent',
    color: 'inherit',
  },
} as const;

// Dark palette variant — tokens are mode-aware via tokens.css :root /
// [data-theme-mode='dark'] split, so most keys can be inherited.
export const MuiAppBarDarkOverrides = {
  ...MuiAppBarLightOverrides,
} as const;
